export default "__VITE_ASSET__Bs03gyxK__"